export const LIMITED_NUMBER_OF_BRANDS = 5;
